'use client'

import { faX } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { useVersionCheck } from '@/hooks/useVersionCheck'

export const VersionUpdateAlert = () => {
  const { showUpdateAlert, dismissAlert, reloadPage } = useVersionCheck()

  if (!showUpdateAlert) return null

  return (
    <div className="fixed bottom-4 z-50 w-full text-center justify-center">
      <div className="w-100 m-auto px-10">
        <div className="alert alert-info shadow-lg flex justify-between">
          <span className="text-md">New version available!</span>
          <div>
            <button
              className="btn btn-sm btn-primary mr-2"
              onClick={reloadPage}
            >
              Update
            </button>
            <button className="btn btn-sm " onClick={dismissAlert}>
              <FontAwesomeIcon icon={faX} className="-pr-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
